export const BOOKSHELF_PLUS_IDS = ['tqh6', '2wb2', 'bookshelf_plus', 'BookshelfPlus']
export const DIGITAL_VIP_IDS = ['digital_vip']
